import { Routes } from '@angular/router';
import { RoleGuard } from '../core/guards/auth.guard';
import { Permission } from '../core/models/role-permissions.models';

export default [
	{
		path: '',
		loadComponent: () =>
			import('./pages/identities-list/identities-list.component').then((m) => m.IdentitiesListComponent),
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.PERSON_VIEW],
			comeback: 'panel',
		},
	},
	{
		path: 'detail/:id',
		loadComponent: () =>
			import('./pages/identities-detail/identities-detail.component').then((m) => m.IdentitiesDetailComponent),
		canActivate: [RoleGuard],
		data: {
			roles: [Permission.PERSON_VIEW],
			comeback: 'identities',
		},
	},
] as Routes;
